import React, { useCallback, useState } from 'react';
import debounce from 'lodash/debounce';

type UseDebounceReturn = [
  string,
  (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void,
  React.Dispatch<React.SetStateAction<string>>
];

const useDebounce = (
  defaultValue: string = '',
  onDebounce?: (text: string) => void,
  preventDebounce?: (text: string) => boolean
): UseDebounceReturn => {
  const [text, setText] = useState(defaultValue);
  const _debounce = useCallback(debounce((_text: string) => {
    if (preventDebounce && preventDebounce(_text)) return;
    if (!onDebounce) return;
    onDebounce(_text);
  }, 200), []);
  const onChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const _text = e.target.value;
    setText(_text);
    _debounce(_text);
  };
  return [text, onChange, setText];
};

export default useDebounce;
